/* eslint-disable */

const initDebug = () => {
  window.debug = {};
  window.isDev = true;

  if (window.location.host.includes('localhost')) {
    // Prevents logging in prod?
    for (const m in console) {
      if (typeof console[m] === 'function') {
        window.debug[m] = console[m].bind(window.console);
      }
    }
  } else {
    for (const m in console) {
      if (typeof console[m] === 'function') {
        window.debug[m] = Function.prototype;
      }
    }
  }
};

/* eslint-enable */

export default initDebug();



// WEBPACK FOOTER //
// ./src/utils.js